// TODO: add props
import React from 'react';
import { ListDivider } from 'components/List';

// TODO: Use <HorizontalDivider />
/** Divider for MoreButton menu items.
 * Any other props will be provided to the wrapper element.
 */
const MoreButtonItemDivider = React.forwardRef<HTMLElement>((props, ref) => <ListDivider ref={ref} {...props} />);

MoreButtonItemDivider.displayName = 'MoreButtonItemDivider';

export default MoreButtonItemDivider;
